module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_1000_Active@1x-5d50336be900b52b15bfeb922c30969f.png";